var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import PropTypes from 'prop-types';

var Svg = function Svg(_ref) {
    var width = _ref.width,
        height = _ref.height,
        style = _ref.style,
        className = _ref.className,
        children = _ref.children,
        resizeWithWindow = _ref.resizeWithWindow;
    return React.createElement(
        'div',
        { className: 'svg-container', style: _extends({}, style, !resizeWithWindow ? { width: width + 'px', height: height + 'px' } : {}) },
        React.createElement(
            'svg',
            {
                className: 'svg-content ' + className,
                viewBox: '-' + width / 2 + ' -' + height / 2 + ' ' + width + ' ' + height,
                preserveAspectRatio: "xMidYMid meet"
            },
            React.createElement(
                'g',
                null,
                children
            )
        )
    );
};

Svg.propTypes = process.env.NODE_ENV !== "production" ? {
    width: PropTypes.number,
    height: PropTypes.number,
    style: PropTypes.object,
    children: PropTypes.arrayOf(PropTypes.node),
    resizeWithWindow: PropTypes.bool
} : {};

export default Svg;